
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftBottom25 as ObiThreewayStackedInleftBottom25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-bottom-25.js';
 
 
 

 
 export const ObiThreewayStackedInleftBottom25 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-bottom-25',
   elementClass: ObiThreewayStackedInleftBottom25Element,
   events: {
     
   }
  });
 
 